import { Link } from 'react-router-dom'

export const NotFoundScreen = () => (
  <section className="max-w-prose space-y-3">
    <h1 className="text-2xl font-semibold tracking-tight">Page not found</h1>
    <p className="text-slate-600">That address doesn't match anything in the app.</p>
    <Link to="/" className="inline-block text-slate-900 underline underline-offset-4">
      Back to the dashboard
    </Link>
  </section>
)
